import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="py-5 px-4 text-center text-xs text-[#4C4D57]/60 border-t border-black/5 bg-[#FBF8F3]">
      © 2026 El Club de Manri · 18 Innovación Educativa, S.L.{' '}
      <span className="mx-1">·</span>
      <Link to="/privacidad" className="underline hover:text-[#48293A] transition-colors">Política de privacidad</Link>
      <span className="mx-1">·</span>
      <Link to="/aviso-legal" className="underline hover:text-[#48293A] transition-colors">Aviso legal</Link>
    </footer>
  );
}
